import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgBingLogoSmall = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__a)">
        <path
          d="M10.152 7.855c-.002.017-.002.036-.002.055 0 .073.015.143.041.207l.024.049.092.237.482 1.23.42 1.073c.12.216.313.387.544.477l.072.027c.003 0 .008 0 .011.002l1.152.396.44.152.03.01.005.001a1.685 1.685 0 0 1 1.035.776 1.692 1.692 0 0 1 .225 1.115v.002l-.014.076-.014.074-.004.008a1.313 1.313 0 0 1-.067.217 1.506 1.506 0 0 1-.14.28 1.704 1.704 0 0 1-.183.244 3.762 3.762 0 0 0 1.002-2.84A3.769 3.769 0 0 0 14.09 9.2c-.191-.177-.4-.334-.624-.467l-.423-.217-2.147-1.101a.538.538 0 0 0-.744.44Z"
          fill="#7F7F7F"
        />
        <path
          d="M10.152 7.855c-.002.017-.002.036-.002.055 0 .073.015.143.041.207l.024.049.092.237.482 1.23.42 1.073c.12.216.313.387.544.477l.072.027c.003 0 .008 0 .011.002l1.152.396.44.152.03.01.005.001a1.685 1.685 0 0 1 1.035.776 1.692 1.692 0 0 1 .225 1.115v.002l-.014.076-.014.074-.004.008a1.313 1.313 0 0 1-.067.217 1.506 1.506 0 0 1-.14.28 1.704 1.704 0 0 1-.183.244 3.762 3.762 0 0 0 1.002-2.84A3.769 3.769 0 0 0 14.09 9.2c-.191-.177-.4-.334-.624-.467l-.423-.217-2.147-1.101a.538.538 0 0 0-.744.44Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__b)"
        />
        <path
          d="M6.332 3a.561.561 0 0 0-.55.561v9.786a1.868 1.868 0 0 0 .026.314 1.674 1.674 0 0 0 2.45 1.177l.086-.052.346-.203.44-.262.001-8.694a1.679 1.679 0 0 0-.762-1.41L6.656 3.095A.57.57 0 0 0 6.352 3h-.02Z"
          fill="#7F7F7F"
        />
        <path
          d="M6.332 3a.561.561 0 0 0-.55.561v9.786a1.868 1.868 0 0 0 .026.314 1.674 1.674 0 0 0 2.45 1.177l.086-.052.346-.203.44-.262.001-8.694a1.679 1.679 0 0 0-.762-1.41L6.656 3.095A.57.57 0 0 0 6.352 3h-.02Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__c)"
        />
        <path
          d="m13.126 11.94-3.94 2.335-.057.035v.012l-.44.26-.346.205-.085.051-.006.003a1.674 1.674 0 0 1-2.446-1.18 3.785 3.785 0 0 0 3.385 3.32h.728c.644-.066 1.182-.324 1.747-.672l.869-.532c.391-.25 1.453-.867 1.766-1.214a1.707 1.707 0 0 0 .392-.74l.018-.083a1.698 1.698 0 0 0-.994-1.882 1.546 1.546 0 0 0-.254-.087h-.003l-.03-.01-.304.18Z"
          fill="#7F7F7F"
        />
        <path
          d="m13.126 11.94-3.94 2.335-.057.035v.012l-.44.26-.346.205-.085.051-.006.003a1.674 1.674 0 0 1-2.446-1.18 3.785 3.785 0 0 0 3.385 3.32h.728c.644-.066 1.182-.324 1.747-.672l.869-.532c.391-.25 1.453-.867 1.766-1.214a1.707 1.707 0 0 0 .392-.74l.018-.083a1.698 1.698 0 0 0-.994-1.882 1.546 1.546 0 0 0-.254-.087h-.003l-.03-.01-.304.18Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__d)"
        />
        <path
          opacity={0.15}
          d="M14.74 13.421a1.745 1.745 0 0 1-.115.618 1.727 1.727 0 0 1-.324.524c-.313.346-1.375.963-1.766 1.214l-.87.532c-.636.392-1.238.67-1.997.69a3.813 3.813 0 0 1-.252-.002 3.782 3.782 0 0 1-3.61-3.336 1.674 1.674 0 0 0 2.446 1.18l.006-.003.085-.05.346-.205.44-.261v-.012l.057-.035 3.94-2.335.304-.18.03.01.003.001a1.684 1.684 0 0 1 1.035.776c.154.255.242.555.242.874Z"
          fill="#7F7F7F"
        />
        <path
          opacity={0.15}
          d="M14.74 13.421a1.745 1.745 0 0 1-.115.618 1.727 1.727 0 0 1-.324.524c-.313.346-1.375.963-1.766 1.214l-.87.532c-.636.392-1.238.67-1.997.69a3.813 3.813 0 0 1-.252-.002 3.782 3.782 0 0 1-3.61-3.336 1.674 1.674 0 0 0 2.446 1.18l.006-.003.085-.05.346-.205.44-.261v-.012l.057-.035 3.94-2.335.304-.18.03.01.003.001a1.684 1.684 0 0 1 1.035.776c.154.255.242.555.242.874Z"
          fill="url(#src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__e)"
        />
      </g>
      <defs>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__b"
          x1={10.79}
          y1={7.972}
          x2={15.265}
          y2={12.96}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37BDFF" />
          <stop offset={0.25} stopColor="#26C6F4" />
          <stop offset={0.5} stopColor="#15D0E9" />
          <stop offset={0.75} stopColor="#3BD6DF" />
          <stop offset={1} stopColor="#62DCD4" />
        </linearGradient>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__c"
          x1={7.686}
          y1={14.831}
          x2={7.542}
          y2={3.763}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B48EF" />
          <stop offset={0.5} stopColor="#2080F1" />
          <stop offset={1} stopColor="#26B8F4" />
        </linearGradient>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__d"
          x1={10.273}
          y1={14.371}
          x2={21.105}
          y2={14.371}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#39D2FF" />
          <stop offset={0.5} stopColor="#248FFA" />
          <stop offset={1} stopColor="#104CF5" />
        </linearGradient>
        <linearGradient
          id="src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__e"
          x1={10.273}
          y1={14.371}
          x2={21.105}
          y2={14.371}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} />
        </linearGradient>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__bing-logo-small_svg__a">
          <path fill="#fff" transform="translate(5 3)" d="M0 0h10.573v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgBingLogoSmall;
